import { render, staticRenderFns } from "./ItemLocaIcon.vue?vue&type=template&id=748c3d65&scoped=true&"
import script from "./ItemLocaIcon.vue?vue&type=script&lang=js&"
export * from "./ItemLocaIcon.vue?vue&type=script&lang=js&"
import style0 from "./ItemLocaIcon.vue?vue&type=style&index=0&id=748c3d65&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748c3d65",
  null
  
)

export default component.exports